jQuery(document).ready(function($) {



});


jQuery(document).ready(function($) {

});
jQuery(document).ready(function($) {

});


$(function(){
var recentlyItemsCard = $('.recently-items-card').length;
var slickXl;
var slickMd;
var slickSm;

if (recentlyItemsCard >= 5) {
  slickXl = 5
} else {
  slickXl = recentlyItemsCard
};

if (recentlyItemsCard >= 3) {
  slickMd = 3
} else {
  slickMd = recentlyItemsCard
};

if (recentlyItemsCard >= 2) {
  slickSm = 2
} else {
  slickSm = recentlyItemsCard
};

  $('.main-slick').slick({
  	slidesToShow: slickXl,
  	slidesToScroll: 5,
  	speed: 300,
  	
  	responsive: [
  	    {
  	      breakpoint: 1200,
  	      settings: {
  	        slidesToShow: slickMd,
  	        slidesToScroll: 3,
  	        
  	      }
  	    },
  	    {
  	      breakpoint: 686,
  	      settings: {
  	        slidesToShow: slickSm,
  	        slidesToScroll: 2,
  	       
  	      }
  	    }
  	    
  	    // You can unslick at a given breakpoint now by adding:
  	    // settings: "unslick"
  	    // instead of a settings object
  	  ]
  })
});
// slick end

//product card quntity 
$(function(){ 

var elem = { 
inp: $('.qty'), 
addBtn: $('.inp-add'), 
rmvBtn: $('.inp-rmv'), 
lastVal: '' 
} 

elem.lastVal = elem.inp.val(); 

elem.inp.on('input', function(e){ 
switch( check(e) ){ 
case true:
console.log();
$(this)["0"].setAttribute('value', $(this).prop('value')); 
break; 
case false: 
$(this)["0"].setAttribute('value', $(this).attr('min'));

break; 
} 
}); 

elem.addBtn.on('click', function(e){ 
check(e, 'up') ? add($(this)) : 0; 
}); 

elem.rmvBtn.on('click', function(e){ 
check(e, 'down') ? rmv($(this)) : 0; 
}); 

function add(clickElem){ 
var input = findInput(clickElem); 

var curVal = input.val(); 
var newVal = parseInt(curVal) + 1 || input.attr('min'); 

input["0"].setAttribute('value', newVal);
elem.lastVal = input.val(); 
} 

function rmv(clickElem){ 
var input = findInput(clickElem); 

var curVal = input.val(); 
var newVal = parseInt(curVal) - 1 || input.attr('min'); 

input["0"].setAttribute('value', newVal);
elem.lastVal = input.val(); 
} 

function check(e, direction){ 
if ( $(e.currentTarget).hasClass('qty') ){ 

var curVal = $(e.currentTarget).prop('value'); 

} else { 

var curVal = findInput( $(e.currentTarget) ).prop('value'); 

} 

var min = parseInt( findInput( $(e.currentTarget) ).attr('min')); 
var max = parseInt( findInput( $(e.currentTarget) ).attr('max')); 

if (isNaN(curVal)){ 
curVal = ''; 
} 

switch(direction){ 
case 'up': 
if ( curVal < max ) { 
return true; 
} else if ( curVal == '' ) { 
return true; 
} else { 
return false; 
} 
break; 
case'down': 
if ( curVal > min ) { 
return true; 
} else { 
return false; 
} 
break; 
default: 
console.log(curVal, min, max); 
if ( curVal >= min && curVal <= max ){ 
return true; 
} else if (curVal == '' && e.originalEvent.data != 0) { 
return true; 
} else { 
return false; 
} 
break; 
} 
} 

function findInput(clickElem){ 
return clickElem.parent().find('.qty'); 
} 
});

// like icon
$(".fa-heart").hover(function(){
  $(this).toggleClass("fas")
});
$(".fa-heart").click(function(){
  $(this).toggleClass("fas")
});

//saved items page
$(".fa-heart").hover(function(){
  $(this).toggleClass("far")
});
$(".fa-heart").click(function(){
  $(this).toggleClass("far")
});

$(".grid-columns-2").click(function(){
  $(".gridMain").css('grid-template-columns', 'repeat(2, 1fr)').css('grid-auto-rows', '1fr');
  $(this).css('color', '#e4a220')
  $(".grid-columns-5").css('color', '#ccc')
});
$(".grid-columns-5").click(function(){
  $(".gridMain").css('grid-template-columns', 'repeat(5, 1fr)');
  $(this).css('color', '#e4a220')
  $(".grid-columns-2").css('color', '#ccc')
});

//drop-menu

//search
$(".img-search").click(function(){
  $(".drop-menu-search").toggleClass("d-block");
  $(".drop-menu-sort").removeClass("d-block");
  $(".sort-order").removeClass("color-active");
  $(".drop-menu-show-products").removeClass("d-block");
  $(".show-products").removeClass("color-active");
  $(".drop-menu-shop-more").removeClass("d-block")
});
$(".drop-menu-search").hover(function(e){
  if ($(".drop-menu-search").has(e.target).length === 0) {
    $(".drop-menu-search").removeClass("d-block")
  }
});
//sort
$(".sort-order").click(function(){
  $(".drop-menu-sort").toggleClass("d-block");
  $(this).toggleClass("color-active");
  $(".drop-menu-search").removeClass("d-block");
  $(".drop-menu-show-products").removeClass("d-block");
  $(".show-products").removeClass("color-active");
  $(".drop-menu-shop-more").removeClass("d-block")
});
$(".drop-menu-sort").hover(function(e){
  if ($(".drop-menu-sort").has(e.target).length === 0) {
    $(".drop-menu-sort").removeClass("d-block");
    $(".sort-order").removeClass("color-active")
  }
});
//show products
$(".show-products").click(function(){
  $(".drop-menu-show-products").toggleClass("d-block");
  $(this).toggleClass("color-active");
  $(".drop-menu-search").removeClass("d-block");
  $(".drop-menu-sort").removeClass("d-block");
  $(".sort-order").removeClass("color-active");
  $(".drop-menu-shop-more").removeClass("d-block")
});
$(".drop-menu-show-products").hover(function(e){
  if ($(".drop-menu-show-products").has(e.target).length === 0) {
    $(".drop-menu-show-products").removeClass("d-block")
    $(".show-products").removeClass("color-active")
  }
});
//shop more
$(".shop-more").hover(function(){
  $(".drop-menu-shop-more").addClass("d-block");
  $(".drop-menu-search").removeClass("d-block");
  $(".drop-menu-sort").removeClass("d-block");
  $(".sort-order").removeClass("color-active");
  $(".drop-menu-show-products").removeClass("d-block");
  $(".show-products").removeClass("color-active");
});
$(".drop-menu-shop-more").hover(function(e){
  if ($(".drop-menu-shop-more").has(e.target).length === 0) {
    $(".drop-menu-shop-more").removeClass("d-block")
  }
});

